import React from 'react'
export default function TransitionScale({ children }) {
  return (
    <div className="transition duration-200 transform hover:scale-110 ease-in-out">
      {children}
    </div>
  )
}
